import { Icon, Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiX } from 'react-icons/pi';
import { SETTLEMENT_ORDER_STATUS } from 'services/settlement/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledSettlementOrderStatusProps {
  status: SETTLEMENT_ORDER_STATUS;
}

interface ILabeledSettlementOrderStatusParams extends IColorProp {
  status: SETTLEMENT_ORDER_STATUS;
  icon: ReactNode;
}

const labeledSettlementOrderParams: ILabeledSettlementOrderStatusParams[] = [
  // {
  //   status: SETTLEMENT_ORDER_STATUS.waiting,
  //   color: 'black',
  //   icon: <PiClock />,
  // },
  {
    status: SETTLEMENT_ORDER_STATUS.inProgress,
    color: 'green',
    icon: <PiCheck />,
  },
  // {
  //   status: SETTLEMENT_ORDER_STATUS.done,
  //   color: 'green',
  //   icon: <PiCheckCircle />,
  // },
  // {
  //   status: SETTLEMENT_ORDER_STATUS.error,
  //   color: 'red',
  //   icon: <PiWarningCircle />,
  // },
  // {
  //   status: SETTLEMENT_ORDER_STATUS.canceled,
  //   color: 'gray',
  //   icon: <PiXCircle />,
  // },
  {
    status: SETTLEMENT_ORDER_STATUS.request,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: SETTLEMENT_ORDER_STATUS.rejected,
    color: 'red',
    icon: <PiX />,
  },
];

const LabeledSettlementOrderStatus = ({
  status,
}: ILabeledSettlementOrderStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledSettlementOrderParams.find(params => params.status === status) ??
    labeledSettlementOrderParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(
        `enum.SETTLEMENT_ORDER_STATUS.${
          SETTLEMENT_ORDER_STATUS[labeledParams.status]
        }`
      )}>
      {labeledParams.icon}{' '}
      {t(
        `enum.SETTLEMENT_ORDER_STATUS.${
          SETTLEMENT_ORDER_STATUS[labeledParams.status]
        }`
      )}
    </Label>
  );
};

export default LabeledSettlementOrderStatus;
